export default __webpack_public_path__ + "static/media/309.d108d9d5.png";